
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/kohler-care",
      function () {
        return require("private-next-pages/india/kohler-care.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/kohler-care"])
      });
    }
  